export default {
  getPages: 'pages/GET_PAGES',
  getPagesSuccess: 'pages/GET_PAGES_SUCCESS',
  getPagesFailure: 'pages/GET_PAGES_FAILURE',

  getPage: 'pages/GET_PAGE',
  getPageSuccess: 'pages/GET_PAGE_SUCCESS',
  getPageFailure: 'pages/GET_PAGE_FAILURE',

  store: 'pages/STORE',
  storeSuccess: 'pages/STORE_SUCCESS',
  storeFailure: 'pages/STORE_FAILURE',

  patch: 'PAGES/PATCH',
  patchSuccess: 'PAGES/PATCH_SUCCESS',
  patchFailure: 'PAGES/PATCH_FAILURE',

  update: 'pages/UPDATE',
  updateSuccess: 'pages/UPDATE_SUCCESS',
  updateFailure: 'pages/UPDATE_FAILURE',

  delete: 'pages/DELETE',
  deleteSuccess: 'pages/DELETE_SUCCESS',
  deleteFailure: 'pages/DELETE_FAILURE',

  getKnowledgeHub: 'pages/GET_KNOWLEDGE_HUB',
  getKnowledgeHubSuccess: 'pages/GET_KNOWLEDGE_HUB_SUCCESS',
  getKnowledgeHubFailure: 'pages/GET_KNOWLEDGE_HUB_FAILURE',

  getCategory: 'pages/GET_CATEGORY',
  getCategorySuccess: 'pages/GET_CATEGORY_SUCCESS',
  getCategoryFailure: 'pages/GET_CATEGORY_FAILURE',

  getCategories: 'pages/GET_CATEGORIES',
  getCategoriesSuccess: 'pages/GET_CATEGORIES_SUCCESS',
  getCategoriesFailure: 'pages/GET_CATEGORIES_FAILURE',

  createCategory: 'pages/CREATE_CATEGORY',
  createCategorySuccess: 'pages/CREATE_CATEGORY_SUCCESS',
  createCategoryFailure: 'pages/CREATE_CATEGORY_FAILURE',

  updateCategory: 'pages/UPDATE_CATEGORY',
  updateCategorySuccess: 'pages/UPDATE_CATEGORY_SUCCESS',
  updateCategoryFailure: 'pages/UPDATE_CATEGORY_FAILURE',

  deleteCategory: 'pages/DELETE_CATEGORY',
  deleteCategorySuccess: 'pages/DELETE_CATEGORY_SUCCESS',
  deleteCategoryFailure: 'pages/DELETE_CATEGORY_FAILURE',
};
